import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = ["src", "title"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VueCropper = _resolveComponent("VueCropper")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!_ctx.clicked)
      ? (_openBlock(), _createElementBlock("img", {
          key: 0,
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.showCropper && _ctx.showCropper(...args))),
          src: _ctx.result.image_url,
          title: _ctx.result.title,
          class: "image-result"
        }, null, 8, _hoisted_1))
      : _createCommentVNode("", true),
    _createVNode(_component_VueCropper, {
      class: _normalizeClass({'hidden': !_ctx.clicked}),
      onReady: _ctx.ready,
      onCropend: _ctx.cropend,
      ref: "cropper",
      title: _ctx.result.title,
      src: _ctx.result.image_url,
      rotatable: false,
      scalable: false,
      zoomable: false,
      viewMode: 1,
      aspectRatio: 1,
      minCropBoxWidth: 200,
      minCropBoxHeight: 200,
      checkCrossOrigin: false
    }, null, 8, ["class", "onReady", "onCropend", "title", "src"])
  ], 64))
}